import { DiscountValueType } from "@redotech/redo-model/discount";
import {
  BasicShopifyDiscountConfiguration,
  DiscountSettings,
} from "@redotech/redo-model/discount/discount-db-parser";
import { RedoRecommendedProduct } from "@redotech/redo-model/redo-recommended-product-schema";
import { assertNever } from "@redotech/util/type";

export const isExpiredDiscount = (endsAt: Date) => {
  if (
    endsAt &&
    Temporal.Instant.compare(
      Temporal.Instant.from(endsAt.toISOString()),
      Temporal.Now.instant(),
    ) < 0
  ) {
    return true;
  }
  return false;
};

export const validDiscount = (discountSettings: DiscountSettings) => {
  if (discountSettings && discountSettings.endsAt) {
    return !isExpiredDiscount(discountSettings.endsAt);
  }
  return false;
};

export const calculateDiscountPrice = (
  product: RedoRecommendedProduct,
  discountSettings: BasicShopifyDiscountConfiguration,
): { price: number; discounted: boolean } => {
  if (discountSettings.appliesToCollections?.length) {
    const isInCollection = product.collections.nodes.some((collection) =>
      discountSettings.appliesToCollections?.includes(collection.id),
    );
    return {
      price: determineDiscountAmount(discountSettings, product).price,
      discounted: isInCollection,
    };
  }
  if (discountSettings.appliesToProducts?.length) {
    const isInProduct = product.variants.nodes.some((variant) =>
      discountSettings.appliesToProducts?.includes(variant.id),
    );
    return {
      price: determineDiscountAmount(discountSettings, product).price,
      discounted: isInProduct,
    };
  }
  return {
    price: determineDiscountAmount(discountSettings, product).price,
    discounted: true,
  };
};

const determineDiscountAmount = (
  discountSettings: BasicShopifyDiscountConfiguration,
  product: RedoRecommendedProduct,
) => {
  switch (discountSettings.discountValueType) {
    case DiscountValueType.PERCENTAGE:
      return {
        price:
          product.price -
          (product.price * (discountSettings.discountValueAmount || 0)) / 100,
        discounted: true,
      };
    case DiscountValueType.AMOUNT:
      return {
        price: Math.max(
          0,
          product.price - (discountSettings.discountValueAmount || 0),
        ),
        discounted: true,
      };
    default:
      assertNever(discountSettings.discountValueType);
  }
};
